<div [ngClass]="{ 'content-box py-1': inContentBox }">
  <ng-container *ngFor="let link of availableLanguages">
    <ng-container *shrdUtcLet="link.language === currentLanguage.language as isCurrentLang">
      <a
        [attr.rel]="isCurrentLang ? null : 'alternate'"
        [href]="inAemContext ? hrefPath + link.language : '/' + link.language + hrefPath"
        [hreflang]="link.language"
        shrdUicButton
        variant="tertiaryFlyout"
        class="w-100 m-0"
        (click)="switchLang(isCurrentLang ? null : link.language)"
      >
        <span>{{ link.label | titlecase }}</span>
        <shrd-uic-svg-icon *ngIf="isCurrentLang" class="shrd-uic-svg-icon" icon="tick" size="small"></shrd-uic-svg-icon>
      </a>
    </ng-container>
  </ng-container>
</div>
